export const shouldSkipDoorToggle = ({
    noInteractions,
    isToggling,
}: {
    noInteractions?: boolean;
    isToggling: boolean;
}): boolean => {
    return Boolean(noInteractions) || isToggling;
};

export const getNextDoorOrDrawerState = (
    isDoorOrDrawerOpen?: boolean
): boolean => {
    return isDoorOrDrawerOpen ? !isDoorOrDrawerOpen : true;
};
